<!-- TODO: API 연동 -->
<template>
  <div class="form_flex_wrap loading_top_wrap">
    <!-- TODO: 예약설정 > AI 예약 설정 -->
    <div class="form_flex_title">
      <span class="title">{{ $t('reservation_settings.section_ai_appointment.title') }}</span>
      <span class="info mgl_auto">{{ $t('reservation_settings.section_ai_appointment.sub_title') }}</span>
    </div>
    <div class="form_flex_cont">
      <table>
        <colgroup>
          <col style="width: 130px;">
          <col style="width: 160px;">
          <col>
          <col style="width: 87px;">
        </colgroup>
        <thead>
          <tr>
            <th>설정</th>
            <th>구분</th>
            <th>내용</th>
            <th>수정</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td rowspan="3" class="title">AI 예약 알림 설정</td>
            <td>AI 예약 시</td>
            <td>
              <div class="pre line-clamp" :title="aiCreateContent">{{ aiCreateContent }}</div>
            </td>
            <td rowspan="3">
              <button class="btn btn_s btn_white ico" @click="showMessageEditPopup">
                <v-icon>mdi-pencil</v-icon> {{ $t('common.edit') }}
              </button>
            </td>
          </tr>
          <tr>
            <td>예약 확정 시</td>
            <td>
              <div class="pre line-clamp" :title="aiConfirmContent">{{ aiConfirmContent }}</div>
            </td>
          </tr>
          <tr>
            <td>예약 삭제 시</td>
            <td>
              <div class="pre line-clamp" :title="aiConfirmContent">{{ aiConfirmContent }}</div>
            </td>
          </tr>
          <tr>
            <td rowspan="3" class="title">AI 예약 상세 설정</td>
            <td>예약 가능 기간</td>
            <td>{{ reservationPeriodText }}</td>
            <td rowspan="3">
              <button class="btn btn_s btn_white ico" @click="showColumnSettingPopup">
                <v-icon>mdi-pencil</v-icon> {{ $t('common.edit') }}
              </button>
            </td>
          </tr>
          <tr>
            <td>예약 시간 간격</td>
            <td>{{ intervalText }}</td>
          </tr>
          <tr>
            <td>시간당 가예약 가능 인원</td>
            <td>{{ maxCapacityText }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- AI 예약 알림 설정 팝업 -->
    <AIReservationMessageEditPopup :isShow="isShowMessageEditPopup" @close="closeMessageEditPopup" />
    <!-- AI 예약 상세 설정 팝업 -->
    <AIReservationDetailEditPopup :isShow="isShowDetailEditPopup" @close="closeDetailEditPopup" />
  </div>
</template>

<script>
import AIReservationMessageEditPopup from './AIReservationMessageEditPopup.vue'
import AIReservationDetailEditPopup from './AIReservationDetailEditPopup.vue'
import { useQueryClient } from '@tanstack/vue-query'
import { reservationGroupAiFindQueryOptions } from '@/composables/queries/reservationgroup/use-reservation-group-ai-find-query'
import { reservationColumnAiFindQueryOptions } from '@/composables/queries/reservationcolumn/use-reservation-column-ai-find-query'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'

export default {
  setup() {
    const queryClient = useQueryClient()
    return { queryClient }
  },
  components: { AIReservationMessageEditPopup, AIReservationDetailEditPopup },
  props: {},
  data() {
    return {
      isLoading: false,
      isSaving: false,

      result: undefined,
      isNotSelectedError: false,
      isTimeSettingError: false,

      isShowMessageEditPopup: false,
      isShowDetailEditPopup: false,

      reservationAiGroup: {},
      reservationAiColumn: {},
    }
  },
  watch: {},
  computed: {
    // 테이블 표시용 텍스트
    reservationPeriodText: function () {
      if (!this.reservationAiColumn?._id) { return '-' }
      const aiSameDayBlockDuration = this.reservationAiColumn?.aiSameDayBlockDuration
      const unitText = this.reservationAiColumn?.aiSameDayBlockType === 'day' ? '일' : '시간'
      const aiPossibleCreateRange = this.reservationAiColumn?.aiPossibleCreateRange
      return `현재 기준 ${aiSameDayBlockDuration}${unitText} 이후부터 ${aiPossibleCreateRange}일까지 예약 등록 가능`
    },
    intervalText: function () {
      if (!this.reservationAiColumn?._id) { return '-' }

      if (!this.reservationAiColumn.aiUsingDefaultAppInterval && this.reservationAiColumn.aiAppTimeIntervals.length > 0) {
        return `직접 설정 (${this.reservationAiColumn.aiAppTimeIntervals.length}개)`
      }
      if (this.reservationAiColumn.aiAppInterval >= 60) {
        const hours = Math.floor(this.reservationAiColumn.aiAppInterval / 60)
        const mins = this.reservationAiColumn.aiAppInterval % 60
        return mins > 0 ? `${hours}시간 ${mins}분` : `${hours}시간`
      }
      return `${this.reservationAiColumn.aiAppInterval}분`
    },
    maxCapacityText: function () {
      return `${this.reservationAiColumn.aiAppMaxCapacity ? `${this.reservationAiColumn.aiAppMaxCapacity}명` : '-'}`
    },

    // AI 예약 관련
    aiCreateContent: function () {
      if (this.reservationAiGroup?.usingCustomAIImmediateCreate) { return this.reservationAiGroup?.customMessageAIImmediateCreate }
      else { return this.reservationAiGroup?.messageAIImmediateCreate }
    },
    aiConfirmContent: function () {
      if (this.reservationAiGroup?.usingCustomAIConfirmation) { return this.reservationAiGroup?.customMessageAIConfirmation }
      else { return this.reservationAiGroup.messageAIConfirmation }
    },
    aiRemoveContent: function () {
      if (this.reservationAiGroup?.usingCustomAIRemove) { return this.reservationAiGroup.customMessageAIRemove }
      else { return this.reservationAiGroup.messageAIRemove }
    },
  },
  mounted() {
    this.loadAiReservationData()
  },
  methods: {
    // 메시지 설정 팝업 열기
    showMessageEditPopup() {
      console.log('showMessageEditPopup')
      this.isShowMessageEditPopup = true
    },
    // 메시지 설정 팝업 닫기
    closeMessageEditPopup() {
      this.isShowMessageEditPopup = false
      this.loadAiReservationData()
    },
    // 상세 설정 팝업 열기
    showColumnSettingPopup() {
      this.isShowDetailEditPopup = true
    },
    // 상세 설정 팝업 닫기
    closeDetailEditPopup() {
      this.isShowDetailEditPopup = false
      this.loadAiReservationData()
    },
    // 상세 설정 저장
    async saveDetailEditPopup(data) {
      try {
        this.isLoading = true
        // TODO: API 호출
        // await this.V2_API.V2AIReservationSetting.update({
        //     hospitalID: this.hospital.selectedHospital._id,
        //     ...data
        // })

        // 임시: 로컬 상태 업데이트
        this.result = {
          ...this.result,
          startValue: data.startValue,
          startUnit: data.startUnit,
          endDays: data.endDays,
          interval: data.interval,
          usingDefaultInterval: data.usingDefaultInterval,
          timeIntervals: data.timeIntervals,
          maxCapacity: data.maxCapacity
        }
        this.closeDetailEditPopup()
      } catch (err) {
        console.log('AI reservation detail update error', err)
      } finally {
        this.isLoading = false
      }
    },

    // MARK: - Ai Reservations
    async loadAiReservationData() {
      await this.findAiReservationGroup()
      await this.findAiReservationColumn()
    },

    async findAiReservationGroup() {
      const hospitalID = this.hospital.selectedHospital._id
      try {
        this.reservationAiGroup = await this.queryClient.fetchQuery(reservationGroupAiFindQueryOptions({
          hospitalID: hospitalID
        }))
      } catch (err) {
        // 기존 동작 미러링: 봉투 code != 0 이면 undefined 대입 (레거시는 data.data 그대로 대입)
        if (!isApiErrorWithCode(err)) throw err
        this.reservationAiGroup = undefined
      }
    },

    async findAiReservationColumn() {
      const hospitalID = this.hospital.selectedHospital._id
      try {
        this.reservationAiColumn = await this.queryClient.fetchQuery(reservationColumnAiFindQueryOptions({
          hospitalID
        }))
      } catch (err) {
        // 기존 동작 미러링: 봉투 code != 0 이면 undefined 대입
        if (!isApiErrorWithCode(err)) throw err
        this.reservationAiColumn = undefined
      }
    }
  }
}
</script>

<style scoped>
.form_flex_cont table {
  width: 100%;
  border: 1px solid #D6DAE0;
}

.form_flex_cont table th {
  height: 28px;
  border-right: 1px solid #D6DAE0;
  border-bottom: 1px solid #D6DAE0;
  background: #F1F3F4;
  font-size: 12px;
  color: #878F9C;
}

.form_flex_cont table td {
  text-align: left;
  padding: 10px;
}

.form_flex_cont table td {
  border-right: 1px solid #D6DAE0;
  border-bottom: 1px solid #D6DAE0;
}

.form_flex_cont table td .pre {
  white-space: pre-wrap;
}

.form_flex_cont table td .pre.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.form_flex_cont table td.title {
  font-weight: bold;
}

.form_flex_cont table tr:last-child td {
  border-bottom-width: 0;
}

.form_flex_cont table td:nth-child(4) {
  border-right-width: 0;
}
</style>